import { render, staticRenderFns } from "./refoundCourse.vue?vue&type=template&id=83bb4bc6&"
import script from "./refoundCourse.vue?vue&type=script&lang=js&"
export * from "./refoundCourse.vue?vue&type=script&lang=js&"
import style0 from "./refoundCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports